export default function getColor(index: number) {
  return 'hsla(' + 36 * index + ',' + '70%,' + '80%,1)';
}
